export default function SafetySection() {
  const safetyItems = [
    { element: 'Ocena sprzedawcy', check: 'Sprawdź rating i historię sprzedawcy przed zakupem' },
    { element: 'Zdjęcia QC', check: 'Zawsze proś o zdjęcia jakości przed wysyłką' },
    { element: 'Cena', check: 'Porównaj cenę z podobnymi produktami na rynku' },
    { element: 'Opinie', check: 'Czytaj doświadczenia innych kupujących' },
    { element: 'Wysyłka', check: 'Sprawdź koszty i czas dostawy do Polski' },
    { element: 'Zwroty', check: 'Zapoznaj się z polityką zwrotów sprzedawcy' },
  ];

  return (
    <section id="safety" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase text-primary-500 mb-3">
            Bezpieczeństwo
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            Bezpieczeństwo zakupów
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            Kakobuy Spreadsheet pomaga znaleźć produkty, ale zawsze sprawdzaj sprzedawcę, opinie oraz informacje dotyczące zakupu. Oto na co zwrócić uwagę:
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-background-100 rounded-lg border border-background-200/70 overflow-hidden">
            <div className="grid grid-cols-2 bg-secondary-50 px-5 py-3.5 border-b border-background-200/60">
              <span className="text-xs font-semibold text-foreground-800 uppercase tracking-wider">Element</span>
              <span className="text-xs font-semibold text-foreground-800 uppercase tracking-wider">Co sprawdzić</span>
            </div>
            <div className="divide-y divide-background-200/50">
              {safetyItems.map((item, idx) => (
                <div key={idx} className="grid grid-cols-2 px-5 py-3.5 hover:bg-background-50 transition-colors">
                  <div className="flex items-center gap-2.5">
                    <div className="w-6 h-6 flex items-center justify-center rounded-full bg-accent-100 shrink-0">
                      <i className="ri-shield-check-line text-accent-500 text-xs"></i>
                    </div>
                    <span className="text-sm font-medium text-foreground-950">{item.element}</span>
                  </div>
                  <span className="text-sm text-foreground-600 leading-relaxed">{item.check}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}